import { useState, useEffect } from "react";

import { Steps } from "antd";

import useUserStore, { selectUserDetails } from "../../store/user/user";
import { FInput } from "../commons/formFields/FInput";
import { fbAuth, Firebase } from "../../services/firebaseService/connection";
// import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

import { afGetClubs } from "../../services/apiFootballService/endPoints/clubs";
import LoadingModal from "../commons/LoadingModal";

import validator from "validator";
import { fbLogoutUser } from "../../services/firebaseService/endPoints/user";
import Axios from "axios";
import { isValidPhoneNumber } from "libphonenumber-js";
import { SolutionOutlined, UserAddOutlined } from "@ant-design/icons";
import { AppStoreBadgeIcon, GooglePlayIcon } from "../../utils/icons.jsx";
import PhoneNumberInput from "../commons/PhoneNumberInput";
// import googleBadget from '../../images/google-play-badget.png'

const Register = (props) => {
  const user = useUserStore(selectUserDetails);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false); // eslint-disable-line no-unused-vars
  const [recaptchaVerifier, setRecaptchaVerifier] = useState(""); // eslint-disable-line no-unused-vars
  const [otp, setOtp] = useState("");
  const [isVerified, setIsVerified] = useState(false); // eslint-disable-line no-unused-vars
  const [confirmResult, setConfirmResult] = useState("");
  const [leaguesList, setLeaguesList] = useState([]); // eslint-disable-line no-unused-vars
  const [league, setLeague] = useState(""); // eslint-disable-line no-unused-vars
  const [clubList, setClubList] = useState([{ name: "Select league first" }]); // eslint-disable-line no-unused-vars
  const [club, setClub] = useState(""); // eslint-disable-line no-unused-vars
  const [registrationCode, setRegistrationCode] = useState("");
  const [showAlert, setShowAlert] = useState({ show: false, type: "success", message: "" });
  const [loginStep, setLoginStep] = useState("process");
  const [verificationStep, setVerificationStep] = useState("wait");
  const [registrationStep, setRegistrationStep] = useState("wait");
  const [doneStep, setDoneStep] = useState("wait"); // eslint-disable-line no-unused-vars
  const [invalidFeedback, setInvalidFeedback] = useState({});
  const [loadingDocument, setLoadingDocument] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  // getDerivedStateFromProps equivalent: if loadingDocument && user.isAuthenticated === false → set loadingDocument false
  useEffect(() => {
    if (loadingDocument && user.isAuthenticated === false) {
      setLoadingDocument(false);
    }
  }, [user.isAuthenticated, loadingDocument]); // eslint-disable-line react-hooks/exhaustive-deps

  // componentDidUpdate equivalent: create recaptchaVerifier when loadingDocument is false
  useEffect(() => {
    if (!loadingDocument && !window.recaptchaVerifier) {
      window.recaptchaVerifier = new Firebase.auth.RecaptchaVerifier(
        "sign-in-button",
        {
          size: "invisible",
          callback: () => {
            // this.handleSubmit()
          },
        }
      );
    }
  });

  const getUrlParameter = (name) => {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    let results = regex.exec(window.location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  };

  // componentDidMount
  useEffect(() => {
    if (user.isAuthenticated) {
      fbLogoutUser();
    }

    const code = getUrlParameter("code");
    if (code) setRegistrationCode(code);

    // componentWillUnmount cleanup
    return () => {
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = "";
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleRequestOtp = () => {
    setIsLoading(true);
    setShowAlert({ show: false });
    setInvalidFeedback({});

    let feedback = {};
    if (!validator.isEmail(email))
      feedback.email = "Enter a valid email";
    if (!name) feedback.name = "Name is required";

    if (Object.keys(feedback).length > 0) {
      setInvalidFeedback(feedback);
      setIsLoading(false);
      return;
    }

    if (!isValidPhoneNumber(phoneNumber)) {
      setShowAlert({
        show: true,
        type: "error",
        message: "Enter a valid phone number",
      });
      setIsLoading(false);
      return;
    }

    fbAuth
      .signInWithPhoneNumber(phoneNumber, window.recaptchaVerifier)
      .then((result) => {
        setConfirmResult(result);
        setShowAlert({ show: false });
        setIsSubmitted(true);
        setIsLoading(false);
        setVerificationStep("process");
        setLoginStep("finish");
      })
      .catch((err) => {
        setShowAlert({ show: true, type: "error", message: err.message });
        setIsLoading(false);
      });
  };

  const handleVerifyOtp = () => {
    setIsLoading(true);
    confirmResult
      .confirm(otp)
      .then((res) => {
        setIsLoading(false);
        setIsVerified(true);
        setShowAlert({ show: false });
        setVerificationStep("finish");
        setRegistrationStep("process");
        // this.handleAlertClose()
        handleMemberRegistration();
      })
      .catch((err) => {
        setIsLoading(false);
        setShowAlert({ show: true, type: "error", message: err.message });
      });
  };

  // getLeagues = () => {
  //     fbGetCurrentLeagues()
  //         .then((leagues) => {
  //             setLeaguesList(leagues)
  //         })
  // }

  // handleLeagueChange = (e) => {
  //     setLeague(e.target.value)
  //     setClubList([])
  //     afGetClubs(e.target.value)
  //         .then((clubs) => {
  //             setClubList(clubs)
  //         })
  // }

  // handleClubChange = (e) => {
  //     setClub(e.target.value)
  // }

  const handleMemberRegistration = async () => {
    // e.preventDefault()

    setIsLoading(true);
    setShowAlert({ show: false });

    Axios.post(`${import.meta.env.VITE_GCP_BASE_URL}/widgets/charge`, {
      regCode: registrationCode,
      uid: fbAuth.currentUser.uid,
      name: name,
      email: email,
      phoneNumber: fbAuth.currentUser.phoneNumber,
      // token: token,
      dontProcess: true,
    })
      .then((response) => {
        setIsLoading(false);
        setShowAlert({
          show: false,
          type: "success",
          message: `You have successfully joined ${response.data.groupName}`,
        });
        setRegistrationStep("finish");
        setDoneStep("finish");
      })
      .catch((err) => {
        setIsLoading(false);
        setShowAlert({
          show: true,
          type: "error",
          message: `${err.response.data.message || "Cant process"} `,
        });
      });

    // fbRegisterMember(this.state.league, this.state.club, Number(this.state.registrationCode), this.state)
    //     .then((group) => {
    //         setShowAlert({ show: false, type: "success", message: `You have successfully joined ${ group }` })
    //         setRegistrationStep('finish')
    //         setDoneStep('finish')
    //         setIsLoading(false)
    //     })
    //     .catch((err) => {
    //         setShowAlert({ show: true, message: err.message, type: 'error' })
    //         setIsLoading(false)
    //     })
  };

  const handleInputChange = (e) => {
    const { name: fieldName, value } = e.target;
    if (fieldName === "name") setName(value);
    else if (fieldName === "email") setEmail(value);
    else if (fieldName === "otp") setOtp(value);
    else if (fieldName === "registrationCode") setRegistrationCode(value);
  };

  const handlePhoneChange = (phone) => {
    if (loginStep === "finish") {
      setLoginStep("process");
      setVerificationStep("wait");
      document.getElementById("phoneNumber").focus();
    }
    setPhoneNumber(phone);
  };

  const handleAlertClose = () => { // eslint-disable-line no-unused-vars
    setShowAlert({ show: false });
  };

  return (
    <div className="container mt-5" style={{ color: "#ffffff" }}>
      {showAlert.show && (
        <div className="alert alert-danger" role="alert">
          {showAlert.message}
        </div>
      )}

      <LoadingModal
        loading={isLoading || loadingDocument}
      />

      <form
        onSubmit={handleSubmit}
        className="border rounded p-2 px-md-5 py-md-4 mx-auto"
        style={{ maxWidth: "700px" }}
      >
        <h6 className="">Supporters Group Registration</h6>
        <Steps className="my-4">
          <Steps.Step
            status={loginStep}
            title="Profile"
            icon={<UserAddOutlined />}
          />
          <Steps.Step
            status={verificationStep}
            title="Verification"
            icon={<SolutionOutlined />}
          />
        </Steps>

        {loginStep === "process" && (
          <>
            <div className="form-group">
              <FInput
                label="Full Name"
                name="name"
                value={name}
                onChange={handleInputChange}
                placeholder="Jessica Smith"
                display="col"
                invalidFeedback={invalidFeedback.name}
                required
              />
            </div>

            <div className="form-group">
              <FInput
                label="Email"
                name="email"
                value={email}
                onChange={handleInputChange}
                placeholder="jessica@gmail.com"
                display="col"
                invalidFeedback={invalidFeedback.email}
                required
              />
            </div>
          </>
        )}

        {verificationStep !== "finish" && (
          <div className="form-group">
            <div className="col">
              <label>
                Phone Number<span style={{ color: "red" }}>*</span>
              </label>
              {/* <PhoneInput
                id="phoneNumber"
                className={`form-control form-control-sm`}
                placeholder="Enter phone number with country code"
                value={phoneNumber}
                onChange={handlePhoneChange}
                country="US"
              /> */}
              <PhoneNumberInput onChange={handlePhoneChange} />
              {verificationStep !== "process" && (
                <div>
                  <span style={{ fontSize: "13px" }}>
                    Note: Phone number will only be used for app
                    authentication as Chant does not use passwords. Message
                    and data rates may apply.
                  </span>
                </div>
              )}

              {/* <div className="invalid">
                                <div className="invalid-feedback">
                                    {invalidFeedback.phoneNumber}
                                </div>
                            </div> */}
            </div>
          </div>
        )}

        {verificationStep !== "finish" && (
          <div
            className={`${
              verificationStep === "process" && "d-none"
            } row justify-content-end m-2`}
            //  style={{ display: `${ verificationStep === 'process' ? 'none' : 'initial' }` }}
          >
            <button
              className="btn btn-primary"
              onClick={handleRequestOtp}
              id={"sign-in-button"}
            >
              Request phone verification code{" "}
            </button>
          </div>
        )}

        {verificationStep === "process" && (
          <>
            {/* <div className="form-group">
                        <div className="col">
                            <label>Phone Number</label>
                            <PhoneInput
                                className={`form - control form - control - sm`}
                                placeholder="Enter phone number"
                                value={phoneNumber}
                                onChange={handlePhoneChange}
                            />
                        </div>
                    </div> */}

            <div className="form-group">
              <FInput
                label="Enter verification code"
                value={otp}
                onChange={handleInputChange}
                name="otp"
                placeholder="Enter code sent via text message"
                display="col"
                required
              />
              {/* <div>
                <span style={{ fontSize: "13px" }}>
                  *Message and data rates may apply.
                </span>
              </div> */}
            </div>

            <div className="row justify-content-end m-2">
              <button
                className="btn btn-primary"
                onClick={handleVerifyOtp}
              >
                Verify
              </button>
            </div>
          </>
        )}

        {/* {registrationStep === "process" && (
          <>
            {/* <FSelect
                        label="Leagues"
                        value={league}
                        onChange={handleLeagueChange}
                        placeholder={leaguesList.length > 0 ? "--Select League--" : "Loading..."}
                        dataList={leaguesList}
                        dataKey="id"
                        dataValue="name"
                        display="col"
                    />
                    <FSelect
                        label="Club"
                        value={club}
                        onChange={handleClubChange}
                        placeholder={clubList.length > 0 ? "--Select Club--" : "Loading..."}
                        dataList={clubList}
                        dataKey="team_id"
                        dataValue="name"
                        display="col"
                    /> */}
        {/* <div className="form-group">
              <div>
                <span style={{ fontSize: "13px" }}>
                  Chant is only $5 per season. Renewal will take place when
                  you renew with your supporters group and is not automatic.
                </span>
              </div> */}
        {/* <FInput
              label="Registration Code"
              value={registrationCode}
              onChange={handleInputChange}
              name="registrationCode"
              placeholder="Enter your 6 digit registration code"
              display="col"
            /> */}
        {/* <Payment
              registrationCode={registrationCode}
              name={name}
              email={email}
              handleMemberRegistration={handleMemberRegistration}
            />
          </div>
        </>
      )} */}

        {registrationStep === "finish" &&
          (showAlert.type !== "success" ? (
            <h6>{showAlert.message}</h6>
          ) : (
            <div>
              <h5 style={{ color: "red" }}>Thank You</h5>
              <p>
                Thanks for registering for Chant. You can now download the app
                and join your supporters group.
              </p>
              <div className="container-links">
                <a
                  href="https://apps.apple.com/us/app/chant/id1477159385?ls=1"
                  style={{ width: "30%" }}
                >
                  <img
                    style={{
                      padding: "0",
                      margin: "auto",
                      width: "100%",

                      // height: "100%"
                    }}
                    src={AppStoreBadgeIcon}
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.geekyants.services.chant"
                  style={{ width: "30%" }}
                >
                  <img
                    style={{
                      padding: "0",
                      margin: "0",
                      width: "100%",
                    }}
                    src={GooglePlayIcon}
                  />
                </a>
              </div>
            </div>
          ))}
      </form>
    </div>
  );
};

export default Register;
